import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 13 }
const _hoisted_2 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_3 = { class: "mt-3 pt-1 d-flex" }
const _hoisted_4 = {
  for: "location-active",
  class: "d-flex align-items-center cursor-pointer"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)
const _hoisted_6 = {
  key: 0,
  for: "country-popular",
  class: "d-flex align-items-center cursor-pointer ms-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Popular", -1)
const _hoisted_8 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_9 = { class: "mt-5" }
const _hoisted_10 = { id: "icon" }
const _hoisted_11 = { class: "w-100 d-flex flex-column justify-content-center" }
const _hoisted_12 = { class: "py-5 d-flex justify-content-center align-items-center" }
const _hoisted_13 = { id: "image1" }
const _hoisted_14 = { class: "w-100" }
const _hoisted_15 = { class: "py-5 d-flex justify-content-center align-items-center" }
const _hoisted_16 = { class: "w-100" }
const _hoisted_17 = { class: "create-location-dropzone create-location-dropzone--160" }
const _hoisted_18 = { class: "drag-and-drop-wrapper" }
const _hoisted_19 = { class: "w-100 mt-4 d-flex flex-column align-items-center" }
const _hoisted_20 = { class: "upload-text text-center w-100" }
const _hoisted_21 = { class: "light-text" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "font-15 w-100 mt-3" }, " Recommended size: 150x150 pixels ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "font-15 w-100" }, " Format: PNG ", -1)
const _hoisted_24 = { id: "image2" }
const _hoisted_25 = { class: "w-100" }
const _hoisted_26 = { class: "py-5 d-flex justify-content-center align-items-center" }
const _hoisted_27 = { class: "w-100" }
const _hoisted_28 = { class: "create-location-dropzone create-location-dropzone--545 ratio-60" }
const _hoisted_29 = { class: "drag-and-drop-wrapper" }
const _hoisted_30 = { class: "w-100 mt-4 d-flex flex-column align-items-center" }
const _hoisted_31 = { class: "upload-text text-center w-100" }
const _hoisted_32 = { class: "light-text" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "font-15 w-100 mt-3" }, " Recommended size: 150x150 pixels ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "font-15 w-100" }, " Format: PNG ", -1)

import {
  TPackageLocation,
  TPackageLocationSingle
} from "@/hooks/esim/location-packages/types/locationPackage.types";
import SelectedNestedLocations from "@/components/Locations/SelectedNestedLocations.vue";
import {
  editLocationData,
  locationImageVariants,
  selectedlocations
} from "@/hooks/locations/new/modules/location.update";
import { IBaseLocation } from "@/api/services/packages/esim/location-packages/types";
import DragAndDrop from "@/components/ui/DragAndDrop.vue";
import { computed, nextTick, Ref, ref, watch } from "vue";
import AppCheckbox from "@/components/Form/AppCheckbox.vue";
import TabsDialog from "@/components/ui/Modal/Dialog/TabsDialog.vue";
import { api } from "@/api/Api";
import { switchedLocation } from "./interfaces";
import AppInputsValidationProvider from "../Form/AppInputsValidationProvider.vue";
import AppInput from "../Form/AppInput.vue";
import AppButton from "../ui/Buttons/AppButton.vue";
import AvatarUpload from "@/components/ui/AvatarUpload.vue";
import SelectLocationsDialog from "./SelectLocationsDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateLocationModal',
  props: {
    windowLoading: { type: Boolean },
    actionLoading: { type: Boolean },
    opened: { type: Boolean },
    locationType: null,
    singleLocationType: null,
    location: null,
    selectedLocationsLists: null,
    baseLocations: null
  },
  emits: {
  hide: null,
  toggleSelectedLocations: null,
  setLocation: null,
  save: null,
  setModalLoading: null
},
  setup(__props: any, { emit }) {

const props = __props as {
  windowLoading: boolean;
  actionLoading: boolean;
  opened: boolean;
  locationType: TPackageLocation;
  singleLocationType: TPackageLocationSingle;
  location: editLocationData;
  selectedLocationsLists: selectedlocations;
  baseLocations: { countries: IBaseLocation[]; subregions: IBaseLocation[] };
};


const currentLocation = ref({ ...props.location });

watch(
  () => props.location,
  () => {
    currentLocation.value = { ...props.location };
  },
  { deep: true, immediate: true }
);



// Validation
const titleValid = ref(!!props.location.title);
const valid = computed(() => !!titleValid.value);
const shakeTree = ref(false);

// Summary
const action = computed(() => (props.location.title ? "edit" : "create"));
const selectListType: Ref<"countries" | "subregions"> = ref("countries");

const baseLoactionsList = computed(() => {
  if (!selectListType.value) return [];
  return props.baseLocations[selectListType.value];
});

const currentLocationsLists = computed(() => {
  return (
    Object.values(props.selectedLocationsLists).find(list => list.length) ?? []
  );
});

// UI
const localOpened = ref(props.opened);
watch(
  () => props.opened,
  opened => {
    localOpened.value = opened;
  },
  { immediate: true }
);

const tabs = ["Details", "Icon", "Image 1", "Image 2"].map((tab, idx) => ({
  title: tab,
  id: idx
}));

const selectedTab = ref(0);

const modalTitle = computed(() => {
  return props.location.title || `New ${props.singleLocationType}`;
});

const buttonText = computed(() => {
  const type = action.value === "create" ? "New" : "Edit";
  return `${type} ${props.singleLocationType}`;
});

const locationsSelectOpened = ref(false);

// Actions
const hide = () => emit("hide");

function changeValidationStatus(error: boolean) {
  titleValid.value = !error;
}

async function setImage(type: locationImageVariants, image: File) {
  if (!image) {
    currentLocation.value[type] = "";
    return;
  }

  emit("setModalLoading", true);

  const { data } = await api.uploadLocationImage({
    type,
    image
  });

  data && (currentLocation.value[type] = data.url);
  emit("setModalLoading", false);
}

async function submitHandler() {
  emit("setLocation", currentLocation.value);
  emit(
    "save",
    action.value,
    {
      name: currentLocation.value.title,
      active: currentLocation.value.active,
      popular: currentLocation.value.popular,
      isoCode: currentLocation.value.isoCode,
      icon: currentLocation.value.icon,
      smallImage: currentLocation.value.smallImage || "",
      bigImage: currentLocation.value.bigImage || ""
    },
    props.location.id
  );
}

function toggleSelectedLocation(location: switchedLocation) {
  emit("toggleSelectedLocations", location);
}

function toggleSelectLocations(
  type: "countries" | "subregions",
  open?: boolean
) {
  if (open) {
    localOpened.value = !open;
    selectListType.value = type;
    nextTick(() => {
      locationsSelectOpened.value = locationsSelectOpened.value = open ?? false;
    });
  } else {
    locationsSelectOpened.value = locationsSelectOpened.value = open ?? false;
    selectListType.value = type;

    nextTick(() => {
      localOpened.value = !open;
    });
  }
}

function saveSelectedLocationsList(locations: switchedLocation[]) {
  locations.forEach(location => {
    toggleSelectedLocation(location);
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SelectLocationsDialog, {
      opened: locationsSelectOpened.value,
      "base-list": _unref(baseLoactionsList),
      "list-type": selectListType.value,
      "location-type": __props.singleLocationType,
      "selected-locations": _unref(currentLocationsLists),
      onSave: saveSelectedLocationsList,
      onHide: _cache[0] || (_cache[0] = ($event: any) => (toggleSelectLocations('countries', false))),
      onBack: _cache[1] || (_cache[1] = ($event: any) => (toggleSelectLocations('countries', false)))
    }, null, 8, ["opened", "base-list", "list-type", "location-type", "selected-locations"]),
    (_openBlock(), _createBlock(TabsDialog, {
      key: 1,
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedTab).value = $event)),
      tabs: _unref(tabs),
      opened: localOpened.value,
      "modal-loading": __props.windowLoading,
      title: _unref(modalTitle),
      class: "create-location-modal",
      onHide: hide
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.opened)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "mt-5",
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
              }, [
                (_openBlock(), _createBlock(AppInputsValidationProvider, {
                  key: 13,
                  "shake-tree": shakeTree.value,
                  onChangeErrorState: changeValidationStatus
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppInput, {
                      id: "location-title",
                      modelValue: currentLocation.value.title,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentLocation.value.title) = $event)),
                      "input-type": "material",
                      label: "Title",
                      "validation-type": "name"
                    }, null, 8, ["modelValue"]),
                    (__props.locationType === 'countries')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(AppInput, {
                            id: "iso",
                            modelValue: currentLocation.value.isoCode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentLocation.value.isoCode) = $event)),
                            label: "ISO",
                            "input-type": "material",
                            "validation-type": "notEmptyString"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["shake-tree"])),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("label", _hoisted_4, [
                    _createVNode(AppCheckbox, {
                      id: "location-active",
                      modelValue: currentLocation.value.active,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentLocation.value.active) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_5
                  ]),
                  (__props.locationType === 'regions')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                        _createVNode(AppCheckbox, {
                          id: "country-popular",
                          modelValue: currentLocation.value.popular,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentLocation.value.popular) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_7
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 32))
            : _createCommentVNode("", true),
          (__props.singleLocationType !== 'country')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(SelectedNestedLocations, {
                  "location-type": __props.singleLocationType,
                  "selected-counties": __props.selectedLocationsLists.countries,
                  "selected-subregions": __props.selectedLocationsLists.subregions,
                  onShowCountriesSelect: _cache[7] || (_cache[7] = ($event: any) => (toggleSelectLocations('countries', true))),
                  onShowSubregionsSelect: _cache[8] || (_cache[8] = ($event: any) => (toggleSelectLocations('subregions', true))),
                  onTurnOff: toggleSelectedLocation
                }, null, 8, ["location-type", "selected-counties", "selected-subregions"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(AppButton, {
              type: "secondary",
              disabled: !_unref(valid),
              loading: __props.actionLoading,
              size: "xl",
              onClick: submitHandler
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ])),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(AvatarUpload, {
                size: "60x60",
                format: "PNG",
                title: `Please, upload ${__props.singleLocationType} Icon.`,
                direction: "column",
                placeholder: __props.location.icon,
                onFileChanged: _cache[9] || (_cache[9] = 
              file => {
                setImage('icon', file);
              }
            )
              }, null, 8, ["title", "placeholder"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(DragAndDrop, {
                      key: "image1",
                      "area-icon": "camera",
                      accepted: ['png'],
                      placeholder: __props.location.smallImage,
                      onFileChanged: _cache[10] || (_cache[10] = 
                    (file) => {
                      setImage('smallImage', file);
                    }
                  )
                    }, null, 8, ["placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", _hoisted_21, " Please, upload " + _toDisplayString(__props.singleLocationType) + " Image ", 1),
                    _hoisted_22,
                    _hoisted_23
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(DragAndDrop, {
                      key: "image2",
                      "area-icon": "camera",
                      accepted: ['png'],
                      placeholder: __props.location.bigImage,
                      onFileChanged: _cache[11] || (_cache[11] = 
                    (file) => {
                      setImage('bigImage', file);
                    }
                  )
                    }, null, 8, ["placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, " Please, upload " + _toDisplayString(__props.singleLocationType) + " Image ", 1),
                    _hoisted_33,
                    _hoisted_34
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "tabs", "opened", "modal-loading", "title"]))
  ], 64))
}
}

})